<div class="card">
  <div class="card-header">{{ title }}</div>
    <div class="card-body" [innerHTML]="messaggio">

    </div>
  <div class="card-footer">
    <button style="cursor:pointer" class="btn btn-primary close-modal" (click)="dismiss()">CHIUDI</button>
  </div>
</div>
